import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";
import { $qs } from "../utils/QuerySelector";


gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);

function randomIntFromInterval(min, max) { // min and max included 
  return Math.floor(Math.random() * (max - min + 1) + min)
}

const rndInt = randomIntFromInterval(10, 15);

const onScroll = () => {  


  // Create parallax effect on images in image-text block 
  gsap.utils.toArray(".js-parallax-trigger .js-parallax-image").forEach((section, i) => {
    const heightDiff = section.offsetHeight - section.parentElement.offsetHeight;

    gsap.fromTo(section,{ 
      y: -heightDiff
    }, {
      scrollTrigger: {
        trigger: section.parentElement,
        start: '-80% top',
        end: '80% top',
        //markers: true,
        scrub: 0.1
      },
      y: 0,
      ease: "none"
    });
  });


  // Create parallax effect on Innovation hub inner page icons
  if ( $qs('.js-parallax-img') !== null  ) {
    const parallaxImgOne = gsap.timeline({ paused: false, });  
    const parallaxImgTwo = gsap.timeline({ paused: false, });  
    const parallaxImgThree = gsap.timeline({ paused: false, });  
    const parallaxImgFour = gsap.timeline({ paused: false, });  
    parallaxImgOne.fromTo( '.js-parallax-img.one', { y: 0, }, { y: -70, ease: "none", }, );
    parallaxImgTwo.fromTo( '.js-parallax-img.two', { y: 0, }, { y: -200, ease: "none", }, );
    parallaxImgThree.fromTo( '.js-parallax-img.three', { y: 0, }, { y: 100, ease: "none", }, );
    parallaxImgFour.fromTo( '.js-parallax-img.four', { y: 0, }, { y: -100, ease: "none", }, );

    ScrollTrigger.create({
      trigger: ".js-parallax-img.one",
      start: 'top 55%',
      end: '120% top',
      scrub: 0.3,
      animation: parallaxImgOne
    })
    ScrollTrigger.create({
      trigger: ".js-parallax-img.two",
      start: 'top 55%',
      end: '120% top',
      scrub: 0.3,
      animation: parallaxImgTwo
    })
    ScrollTrigger.create({
      trigger: ".js-parallax-img.three",
      start: 'top 55%',
      end: '120% top',
      scrub: 0.3,
      animation: parallaxImgThree
    })
    ScrollTrigger.create({
      trigger: ".js-parallax-img.four",
      start: 'top 55%',
      end: '120% top',
      scrub: 0.3,
      animation: parallaxImgFour
    })
  }


};

  




export default onScroll;